import { render, staticRenderFns } from "./Landing.vue?vue&type=template&id=26735c86&"
import script from "./Landing.vue?vue&type=script&lang=ts&"
export * from "./Landing.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26735c86')) {
      api.createRecord('26735c86', component.options)
    } else {
      api.reload('26735c86', component.options)
    }
    module.hot.accept("./Landing.vue?vue&type=template&id=26735c86&", function () {
      api.rerender('26735c86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/standalone/Landing.vue"
export default component.exports